<template>
  <div>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardBody>
            <BTabs :active-tab.sync="active_tab">


              <CTab :title="$t('InventoryAdjustment')">
                <InventoryAdjustment/>
              </CTab>
              <CTab :title="$t('components.temporaryDocuments')">
                <InventoryAdjustmentListPreOrders/>
              </CTab>

              <CTab :title="$t('sidebars.documents')">
                <InventoryAdjustmentListFinal/>
              </CTab>

            </BTabs>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
var items = [];
import BTabs from "../../tabs/BTabs";
import InventoryAdjustment from "../inventoryAdjustment/InventoryAdjustment";
import InventoryAdjustmentListFinal from "../inventoryAdjustment/InventoryAdjustmentListFinal";
import InventoryAdjustmentListPreOrders from "../inventoryAdjustment/InventoryAdjustmentListPreOrders";

export default {
  name: 'Login',
  components: {
    BTabs,
    InventoryAdjustment,
    InventoryAdjustmentListFinal,
    InventoryAdjustmentListPreOrders,
  },
  data() {
    return {

      active_tab:parseInt(localStorage.getItem("sale_factors_active_tab",0)),

    }
  }, mounted() {
    this.$root.root_validate_errors = [];

  }, watch: {
    'active_tab': function () {
      localStorage.setItem("sale_factors_active_tab",this.active_tab)
    },

  },
  methods: {



  }
}

</script>
